// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__4nRsW","sidenav":"Sidebar_sidenav__d0DxF","sidenav__item":"Sidebar_sidenav__item__q737J","sidenav__link":"Sidebar_sidenav__link__pyWHA"};